import React, { useCallback, useMemo } from "react"
import { Box, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { get } from "lodash"

import { useFeatureDetail } from "hooks/feature"
import { usePageSideBarLayout } from "providers/ui/hooks"
import { useGeoLocation } from "providers/geolocation"
import { useTranslation } from "providers/i18n"

import { PageCard, PageCardContent } from "components/card"
import { ProductData } from "providers/venue/types"
import { ProductCard } from "extensions/iconsiam/components/domains/products"
import { PlaceDetailSideBar } from "extensions/iconsiam/components/domains/features/PlaceDetailSideBar"

export const OccupantRecommendedMenuKioskHPage = ({ Layout }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const { t } = useTranslation()
  const { dataLoaded, ...data } = useFeatureDetail()

  const { deviceLocation } = useGeoLocation()
  const isReadyToNavigate = !!deviceLocation && get(data, "isNavigatable", true)

  const { pageCardSideBar } =
    theme.components[`PlaceDetailPage`]?.styleOverrides || {}

  const {
    pageCard,
    pageCardContent,
    pageCardHeaderText,
    productContainer,
    productCard,
  } = theme.components?.[`OccupantRecommendedMenuPage`]?.styleOverrides || {}

  const products = useMemo(
    () => get(data, "products", []) as ProductData[],
    [data]
  )

  const onNavigate = useCallback(() => {
    if (!isReadyToNavigate) return
    navigate(`/maps/dir/unknown/${data?.id}`)
  }, [navigate, isReadyToNavigate, data?.id])

  usePageSideBarLayout({
    sidebar: {
      open: true,
    },
  })

  return (
    <Layout
      aside={
        <PageCard sx={pageCardSideBar}>
          <PlaceDetailSideBar
            data={data}
            onNavigate={onNavigate}
            showAdditionalButtons={false}
          />
        </PageCard>
      }
      children={
        <PageCard sx={pageCard}>
          <PageCardContent sx={pageCardContent}>
            <Typography variant="h3" component="h2" sx={pageCardHeaderText}>
              {t("Recommended Menu")}
            </Typography>
            <Box sx={productContainer}>
              {products.map((product, index) => {
                const coverImage = get(product, "properties.cover_image")
                const name = get(product, "properties.name")
                return (
                  <ProductCard
                    sx={productCard}
                    data={{ name, coverImage }}
                    key={`product-${product?.id}`}
                  />
                )
              })}
            </Box>
          </PageCardContent>
        </PageCard>
      }
    />
  )
}
